module.exports = __webpack_public_path__ + "img/google_circle-512.03112562.png";